import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetNearbyTokenRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetNearbyTokenResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getNearbyToken = (request: GetNearbyTokenRequest, options?: CashRequestOptions) =>
  post<GetNearbyTokenRequest, GetNearbyTokenResponse>('/2.0/cash/get-nearby-token', request, {
    ...options,
    rejectOnError: true,
  })
